import ThreadHeader from "./ThreadHeader";
import Tweet from "./Tweet";

function hasPhoto(tweet) {
  return tweet.media;
}

function hasEmbeddedTweet(tweet) {
  return (
    tweet.referenced_tweets &&
    tweet.referenced_tweets.find((ref) => {
      return ref.type === "quoted";
    })
  );
}

function Thread(props) {
  const { thread, hideCopy, thumbnail } = props;

  const tweets = thumbnail ? [] : thread.tweets;
  if (thumbnail) {
    for (let tweet of thread.tweets) {
      if (hasPhoto(tweet) || hasEmbeddedTweet(tweet)) {
        tweets.push(tweet);
        break;
      }
      tweets.push(tweet);
    }
  }

  return (
    <div
      id="thread-container"
      className="bg-white shadow-md rounded-md font-serif"
    >
      <ThreadHeader thread={thread} hideCopy={hideCopy} />
      <div id="thread-content" className="py-4">
        {tweets.map((tweet) => (
          <Tweet key={tweet.id} tweet={tweet} />
        ))}
      </div>
    </div>
  );
}

export default Thread;
